import React from 'react';

interface FormDatePickerProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  showNeverOption?: boolean;
}

export default function FormDatePicker({
  id,
  label,
  value,
  onChange,
  required = false,
  showNeverOption = false
}: FormDatePickerProps) {
  const handleDateChange = (dateValue: string) => {
    onChange(dateValue);
  };

  return (
    <div>
      <label htmlFor={id} className="block text-supporting font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-error-red">*</span>}
      </label>
      <input
        type="date"
        id={id}
        value={value}
        onChange={(e) => handleDateChange(e.target.value)}
        className="w-full px-4 py-3 border border-border-light rounded-md text-body-lg focus:ring-2 focus:ring-trust-blue/20 focus:border-trust-blue transition-all duration-200 font-inter"
        required={required}
      />
      {showNeverOption && (
        <div className="mt-3">
          <button
            type="button"
            onClick={() => onChange('never')}
            className={`px-4 py-2 rounded-md text-supporting transition-all duration-200 ${
              value === 'never'
                ? 'bg-trust-blue text-pure-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            Never picked up before
          </button>
        </div>
      )}
    </div>
  );
}